import React, { useState } from 'react'
import firebase from '../config/firebaseConfig'
import './styles/form.css'




const UserForm = () => {

    let [name, setName] = useState('')
    let [tienda, setTienda] = useState('')
    let [brand, setBrand] = useState('')
    let [email, setEmail] = useState('')
    let [addres, setAddres] = useState('')
    let [msg, setMsg] = useState('')
    let [tele,setTele] = useState('')
    let [interest,setInterest] =useState('')
    let [fromBool, setFormBool] = useState(false)
    let db = firebase.firestore().collection('userBrand')
    let userData = {
        name: name,
        tienda,
        brand,
        email,
        addres,
        msg,
        tele,
        interest
    }

    const sentData = (e) => {
        e.preventDefault()
        if (name && email) {
            setFormBool(true)
            // console.log(name, city)
            db.doc().set(userData)
                .then(() => {
                    console.log('sent')
                    setFormBool(false)
                })
                .catch((e) => {
                    console.log(e, 'error')
                    setFormBool(false)

                })
            setBrand('')
            setTienda('')
            setEmail('')
            setName('')
            setAddres('')
            setMsg('')
            setTele('')
            setInterest('')

        }
        else {
            // return <div></div>
        }
    }

    return (
        <div id='form'>
            <div className='d-flex form_div'>
                <div className='from_head'>
                    <h3><strong style={{color:'#353336'}} >Contacto <b> Comercial </b></strong></h3>
                </div>
                <form onSubmit={sentData} className='user_from'>
                    <div className="input_six">
                        <div>
                            <div>
                                <label htmlFor="">Nombre completo</label>
                                <input
                                    type="text"
                                    value={name}
                                    required
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div>
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    name='email'
                                    id='email'
                                    value={email}
                                    required={true}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div>
                                <label htmlFor="">Nombre tienda</label>
                                <input
                                    type="text"
                                    required={true}
                                    value={tienda}
                                    onChange={(e) => setTienda(e.target.value)}
                                    />
                            </div>
                        </div>
                        <div>
                            <div>
                                <label htmlFor="Cargo">Teléfono</label>
                                <input
                                    type="text"
                                    value={tele}
                                    required={true}
                                    onChange={(e) => setTele(e.target.value)}
                                    />
                            </div>
                            <div>
                                <label htmlFor="Cargo">Página Web</label>
                                <input
                                    type="text"
                                    required={true}
                                    value={brand}
                                    onChange={(e) => setBrand(e.target.value)}
                                />
                            </div>
                            <div>
                                <label htmlFor="addres">Dirección</label>
                                <input
                                    type="text"
                                    value={addres}
                                    onChange={(e) => setAddres(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <label htmlFor="addres">Marcas de interés</label>
                        <input
                            type="text"
                            value={interest}
                            onChange={(e) => setInterest(e.target.value)}
                        />
                    </div>
                    <div className='textarea_div'>
                        <p className='msg_label'>Mensaje</p>
                        <textarea
                            name="msg"
                            id="msg"
                            cols="56"
                            rows="4"
                            value={msg}
                            onChange={(e) => setMsg(e.target.value)}
                        ></textarea>
                    </div>
                    <button type='submit' disabled={fromBool}>
                        {fromBool ?
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Enviar Formulario</span>
                            </div>
                            : 'Enviar Formulario'
                        }
                        {/* Enviar */}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default UserForm
